












import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { helpContentData } from '@/shared/help-content-data/msw-help-data.ts';
const cssPrefix = 'help-container';

@Component({
  components: {},
})
export default class HelpContainerSlide extends SwExtendedVue {
  cssPrefix = cssPrefix;

  helplink: string = '';

  get helpId() {
    return this.$route.query.helpId;
  }

  mswHelpData: any = [
    { route: 'dashboard', helpId: 'dashboard' },
    { route: 'dashboard', helpId: 'dashboard_listview' },

    { route: 'products', helpId: 'products' },
    { route: 'psa-integration', helpId: 'psa-integration' },
    { route: 'psa-integration', helpId: 'psa-connectwise' },

    { route: 'user-groups', helpId: 'user-groups-users-tab' },
    { route: 'user-groups', helpId: 'user-groups-customer-tab' },
    { route: 'user-groups', helpId: 'user-groups-permission-tab' },

    { route: 'mssp-tenant-mgmt', helpId: 'master-mssp' },
    { route: 'mssp-tenant-mgmt', helpId: 'regular-mssp' },

    { route: 'mssp-access-management', helpId: 'master-mssp-access-mgmt' },
    { route: 'mssp-access-management', helpId: 'regular-mssp-access-mgmt' },

    { route: 'usage-report', helpId: 'master-billing-report' },
    { route: 'usage-report', helpId: 'regular-billing-report' },

    { route: 'quotehistory', helpId: 'quotehistory' },
    { route: 'quoteDetails', helpId: 'quotehistory' },

    { route: 'managecases', helpId: 'managecases' },

    { route: 'download-center', helpId: 'download-center' },
    { route: 'renewalmanager', helpId: 'renewal-manager' },
    { route: 'alerts', helpId: 'notification-center' },
    { route: 'downloadsign', helpId: 'download-signatures' },
    { route: 'nfrrequest', helpId: 'nfr-services' },
    { route: 'activitylogs', helpId: 'activity-log-help' },
    { route: 'freedownloads', helpId: 'freedownloads' },
    { route: 'org-profile', helpId: 'org-account' },
  ];

  mounted() {
    this.helplink = '';
    if (this.helpId) {
      this.mswHelpData.filter((ele: any) => {
        if (ele.helpId === this.helpId) {
          this.setHelpLink(ele.helpId);
        }
      });
    }
  }

  setHelpLink(helpId: any) {
    for (const i of helpContentData) {
      if (i.helpId === helpId) {
        this.helplink = i.content;
      }
    }
  }

  beforeDestroy() {
    this.helplink = '';
  }
}
